import { motion } from "framer-motion";

interface MenuProp {
  toggle: Function;
  isOpen?: boolean;
}

interface PathProp {
  d?: string;
  variants: {
    closed: {
      d?: string;
      opacity?: number;
    };
    open: {
      d?: string;
      opacity?: number;
    };
  };
  transition?: {
    duration: number;
  };
  stroke?: string;
}

const Path = (props: PathProp) => {
  return (
    <motion.path
      fill="transparent"
      strokeWidth="3"
      strokeLinecap="round"
      {...props}
    />
  );
};

const Menu = ({ toggle, isOpen = false }: MenuProp) => (
  <motion.button
    className="lg:hidden relative p-3 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl shadow-lg hover:shadow-yellow-500/60 border-2 border-yellow-400 transition-all"
    onClick={() => toggle()}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    aria-label="Toggle Menu"
  >
    {/* Glow effect */}
    <div className="absolute inset-0 bg-yellow-400/20 rounded-xl blur-sm" />
    
    <motion.svg
      width="24"
      height="24"
      viewBox="0 0 23 23"
      className="relative z-10"
      animate={isOpen ? "open" : "closed"}
    >
      <Path
        stroke="#000000"
        variants={{
          closed: { d: "M 2 2.5 L 20 2.5" },
          open: { d: "M 3 16.5 L 17 2.5" }
        }}
      />
      <Path
        stroke="#000000"
        variants={{
          closed: { d: "M 2 9.423 L 20 9.423", opacity: 1 },
          open: { d: "M 2 9.423 L 20 9.423", opacity: 0 }
        }}
      />
      <Path
        stroke="#000000"
        variants={{
          closed: { d: "M 2 16.346 L 20 16.346" },
          open: { d: "M 3 2.5 L 17 16.346" }
        }}
      />
    </motion.svg>
  </motion.button>
);

export default Menu;